import { useState } from 'react';

import AttackLegend from './AttackLegend';

export default function BattleRulesButton() {
  const [expanded, setExpanded] = useState(false);
  return (
    <div className="battle-rules-button__wrapper">
      <div className={`battle-rules__rules ${expanded && 'battle-rules__rules--expanded'}`}>
        <AttackLegend visible={expanded} />
      </div>
      <button className={`battle-rules-button ${expanded && 'battle-rules-button--expanded'}`} onClick={() => setExpanded(!expanded)} type="button">
        <img src="/img/up.icon.png" alt="Toggle" />
        <span className="battle-rules-button__label">Combat Rules</span>
      </button>
    </div>
  );
}
